import React from 'react';
import { trackEvent } from '../firebaseAnalytics';
import LaunchCta from '../components/LaunchCta';

export default function Pricing(){
  return (
    <section id="pricing" className="section" data-bg="blue">
      <div className="container">
        <div style={{textAlign:'center',marginBottom:22}}>
          <span className="badge"><i className="fi fi-rr-credit-card" style={{fontSize:14,opacity:.9}}></i> PRICING</span>
          <h2 style={{fontSize:'clamp(28px,4vw,46px)',margin:'10px 0'}}>Flexible Plans for Everyone</h2>
          <p className="subtitle" style={{marginTop:0}}>Choose a plan that fits your goals and scale as you grow</p>
          {/* billing switch removed - only showing Monthly label */}
          {/* <div className="switch" role="tablist" aria-label="Billing Period">
            <button className="active" id="bill-monthly">Monthly</button>
            <button id="bill-yearly">Yearly <span className="badge" style={{marginLeft:6, fontSize:'x-small'}}>Save 20%</span></button>
          </div> */}
          {/* <div className="switch" aria-hidden="true" style={{display:'inline-block'}}>
            <span className="active" id="bill-monthly" style={{padding:'8px 14px',borderRadius:8}}>Monthly</span>
          </div> */}

        </div>
        <div className="container" style={{maxWidth:800, marginBottom:32, textAlign:'center'}}>
        <div className="grid grid-2 " >
          <article className="card glass price-col plan">
            <div className="shine" />
            <h4>Free Trial</h4>
            <div className="price" aria-live="polite" style={{display:'flex',flexDirection:'row',justifyContent:'center',gap:6}}>              {/* <span className="price-amount" data-month="_" data-year="_">_</span> */}
              <span className="price-amount" data-month="_">Free</span> 
              {/* <span className="price-period">/mo</span> */}
            </div>
            <div style={{margin:18, textAlign:'center'}}>
              <LaunchCta
                className="btn btn-price"
                style={{width:'100%',justifyContent:'center',padding:'.95rem 1rem'}}
                source="pricing_free_trial"
                withArrow
              />
            </div>
            <ul className="feat">
              <li className="check"><i className="fi fi-br-check"></i>500 credits for model usage</li>
              <li className="check"><i className="fi fi-br-check"></i>Version control</li>
              <li className="check"><i className="fi fi-br-check"></i>Collaboration</li>
              <li className="check"><i className="fi fi-br-check"></i>Prompt DNA</li>
              <li className="check"><i className="fi fi-br-check"></i>Multi-model testing</li>
              <li className="check"><i className="fi fi-br-check"></i>GPT-5 and low-cost models</li>
              <li className="check"><i className="fi fi-br-check"></i>Bring your own key capability</li>
            </ul>
          </article>

          <article className="card glass price-col plan">
            <div className="shine" />
            <h4>Standard</h4>
            <div className="price" aria-live="polite" style={{display:'flex',flexDirection:'row',justifyContent:'center',gap:6}}>
              {/* <span className="price-amount" data-month="_" data-year="_">_</span> */}
              <span className="price-amount" data-month="_" >€25</span> 
              <span className="price-period">/mo</span>
            </div>
            <div style={{margin:18, textAlign:'center'}}>
              <button
                type="button"
                className="btn btn-price btn-price-disabled"
                style={{width:'100%',justifyContent:'center',padding:'.95rem 1rem'}}
                disabled
              >
                Coming soon
              </button>
            </div>
            <ul className="feat">
              <li className="check"><i className="fi fi-br-check"></i>Everything in Free Trial</li>
              <li className="check"><i className="fi fi-br-check"></i>5k/month credits for model usage</li>
              <li className="check"><i className="fi fi-br-check"></i>Usage-based capability</li>
              <li className="check"><i className="fi fi-br-check"></i>Payments</li>
              <li className="check"><i className="fi fi-br-check"></i>OpenAI and Anthropic models</li>
              <li className="check"><i className="fi fi-br-check"></i>Gemini and DeepSeek models</li>
              <li className="check"><i className="fi fi-br-check"></i>Document handling</li>
              <li className="check"><i className="fi fi-br-check"></i>Limited Internet Search, Deep Research, Coding and Image Processing tools</li>

              <li className="check"><i className="fi fi-br-check"></i>Ready-to-use prompt templates</li>
            </ul>
          </article>
          </div>
          {/* <article className="card glass price-col plan">
            <div className="shine" />
            <h4>Enterprise</h4>
            <div className="price" aria-live="polite">
              <span className="price-amount" data-month="_" data-year="_">_</span>
              <span className="price-period">/mo</span>
            </div>
            <div style={{margin:18, textAlign:'center'}}>
              <button
                type="button"
                className="btn btn-price"
                style={{width:'100%',justifyContent:'center',padding:'.95rem 1rem'}}
                onClick={()=>document.getElementById('openWaitlist')?.click()}
              >
                Coming Soon
              </button>
            </div>
            <ul className="feat">
              <li className="check"><i className="fi fi-br-check"></i>On-prem Deployment</li>
              <li className="check"><i className="fi fi-br-check"></i>Enterprise SSO</li>
              <li className="check"><i className="fi fi-br-check"></i>Audit Logging</li>
              <li className="check"><i className="fi fi-br-check"></i>Unlimited AI Agentic Flows</li>
            </ul>
          </article> */}
        </div>
        {/* <div style={{textAlign:'center',marginTop:32}}>
          <button className="btn btn-price" style={{marginTop:'auto'}} onClick={()=>document.getElementById('openWaitlist')?.click()}>Free Trial</button>
        </div> */}
      </div>
    </section>
  );
}
